<template>
  <section>
    <!-- 评论列表 -->
    <div
      class="comment-content"
      :style="{'padding-bottom': isShowComment ? '70px' : '30px','box-sizing': 'border-box'}"
      @click="clickComment"
    >
      <div
        ref="commentList"
        class="comment-list"
      >
        <div
          v-if="commentData&&commentData.length > 0"
          class="scroll-wrapper rpanel-scroll-wrapper"
        >
          <div
            v-for="(item,index) in commentData"
            :key="index"
            class="list-item"
          >
            <comment-item
              :item="item"
              :update-data="updateData&&(updateData.reply_id === item.id)? updateData: null"
              @replyComment="replyComment"
              @modifyComments="modifyComments"
              @showTips="showTips"
            />
          </div>
          <p
            v-show="commentNoMore"
            class="comment-no-more"
          >
            {{ $t('没有更多评论了…') }}
          </p>
        </div>
        <div
          v-else
          class="no-comment"
        >
          <img
            src="./images/no-comment.svg"
            alt=""
          >
          <div class="no-comment-tips">
            {{ $t('暂无评论') }}
          </div>
        </div>
      </div>
    </div>

    <!-- 评论输入框 -->
    <div class="comment-footer">
      <comment-footer
        ref="commentFooter"
        :force-show="forceShow"
        :reply-show-comment="isShowComment"
        @hideFooter="hideFooter"
        @refreshData="refreshData"
        @showTips="showTips"
        @showComment="showComment"
      />
    </div>
  </section>
</template>
<script>

import _$ from 'js/api/getdata.js'
import store from 'store'
import CommentItem from './comment-item.vue'
import CommentFooter from './comment-footer.vue'

export default {
  components: {
    CommentItem,
    CommentFooter,
  },
  data() {
    return {
      commentData: [],
      forceShow: false,
      updateData: null,
      commentNoMore: false,
      commentTotal: 0, // 记录评论总数
      oldScrollHeight: 0, // 记录loadmore之前总高度
      rpanelScrollTimer: undefined, // 评论滚动条防抖
      isShowComment: false, // 是否显示输入框
    }
  },
  computed: {
    selectedData() {
      return store.state.curFileInfo
    },
  },
  watch: {
    selectedData(val) {
      this.resetData()
      this.getComment()
    },
  },
  mounted() {
    this.getComment()
    this.scrollToFooter()// 滚动到底部
    this.commentLoadMore()
  },
  methods: {
    /**
         * 点击评论列表面板，用于关闭评论框
         */
    clickComment() {
      // this.$refs.commentFooter.showComment(false)
    },
    refreshData(data) {
      if (data.reply_id && data.reply_name) {
        // 更新回复数据repliesData
        // 这里穿的数据没有用到，调用接口获得新增数据，这里是作为判断依据
        this.updateData = data
      } else {
        const limit = 1
        this.getComment(limit)
      }
    },
    modifyComments({ type, data }) {
      if (type === 'delete') {
        const { id, neid, nsid } = data
        const commentId = {
          id,
          neid,
          nsid,
        }
        _$.postData('deleteComment', commentId).then(() => {
          const idx = this.commentData.indexOf(data)
          this.commentData.splice(idx, 1)
        }).catch((error) => {
          const err = error.response.data
          window.$toast.simpleShow(err.message, 'error')
        })
      }
    },
    replyComment(value) {
      this.forceShow = value
      this.isShowComment = true
      this.$refs.commentFooter.showCommBtn = false
    },
    showComment(val) {
      this.isShowComment = val
    },
    hideFooter() {
      this.forceShow = false
    },
    getComment(limit = 10, loadMore) {
      const pageNum = loadMore ? this.commentData.length / 10 + 1 : 1
      const data = {
        neid: this.selectedData.neid,
        nsid: this.selectedData.nsid,
        page_num: pageNum,
        num_each_page: limit,
      }
      _$.getData('getComment', data).then((res) => {
        if (res.data.comments && res.data.comments.length > 0) {
          this.commentTotal = res.data.comments_total
          if (limit === 1) {
            this.commentData.push(res.data.comments[0])
            this.scrollToFooter()
          } else if (!loadMore) {
            this.commentData = res.data.comments.reverse()
            this.scrollToFooter()
          } else {
            this.commentData = [...res.data.comments.reverse(), ...this.commentData]
            this.scrollToOldPosition()
          }
        }
      }).catch((error) => {
        const err = error.response.data
        this.$emit('showTips', err.message, 'error')
      })
    },
    commentLoadMore() {
      setTimeout(() => {
        const el = document.querySelector('.rpanel-scroll-wrapper')
        if (el) {
          this.oldScrollHeight = el.scrollHeight
          el.onscroll = () => {
            const { scrollTop } = el
            if (this.rpanelScrollTimer) {
              clearTimeout(this.rpanelScrollTimer)
            }
            this.rpanelScrollTimer = setTimeout(() => {
              if (scrollTop <= 0) {
                // 滚动到顶部loadmore
                const currentLen = this.commentData.length
                if (currentLen < this.commentTotal) { // 当前加载条数少于总评论数执行加载方法
                  this.getComment(10, true)
                } else {
                  this.commentNoMore = true
                }
              }
            }, 300)
          }
        }
      }, 500)
    },
    resetData() {
      this.commentNoMore = false
      this.commentData = []
    },
    scrollToFooter() { // 滚动到底部
      this.$nextTick(() => {
        const div = document.querySelector('.rpanel-scroll-wrapper')
        if (div) {
          div.scrollTop = div.scrollHeight
        }
      })
    },
    scrollToOldPosition() { // 滚动到加载更多之前的位置
      this.$nextTick(function () {
        const div = document.querySelector('.rpanel-scroll-wrapper')
        if (div) {
          div.scrollTop = div.scrollHeight - this.oldScrollHeight
        }
      })
    },
    showTips(msg, type) {
      this.$emit('showTips', msg, type)
    },
  },
}
</script>
<style lang="less" scoped>
// @import '~less/reset.less';
section {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding-bottom: 40px;
}
.add-btn {
  position: relative;
  color: #4D5365;
  margin: 10px 2px 0 2px;
  display: block;
  height: 30px;
  line-height: 30px;
  border: 1px solid #C6CDD7;
  border-radius: 2px;
  text-align: center;
  cursor: pointer;
}
.comment-content {
  height: 100%;
  margin-bottom: 20px;
}
.comment-list {
  height: 100%;
  overflow: auto;
  padding: 0 20px;
  margin-bottom: 20px;
  .scroll-wrapper {
    height: calc(100% - 30px);
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb  {
      opacity: 0.6;
      background: #C1C7CD;
      border-radius: 100px;
    }
    .comment-no-more{
      margin: 10px 0;
      font-size: 12px;
      color: #727E8F;
      text-align: center;
    }
  }
  .scroll-wrapper .list-item:last-child {
    .item-line {
      display: none;
    }
  }
  .no-comment {
    text-align: center;
    img {
      margin: 130px auto 20px;
      height: 130px;
      position: relative;
      width: 130px;
    }
  }
}
.comment-footer {
  display: block;
  margin: -46px auto 0;
  width: 260px;
  position: relative;
}
</style>
